const MARK_START = '%FOODTOGE-MENU-TEXT-v1'
const MARK_END = '%FOODTOGE-MENU-TEXT-END'

function bytesToLatin1(buffer) {
  const bytes = buffer instanceof Uint8Array ? buffer : new Uint8Array(buffer)
  const chunks = []
  const step = 0x8000
  for (let i = 0; i < bytes.length; i += step) {
    chunks.push(String.fromCharCode.apply(null, bytes.subarray(i, i + step)))
  }
  return chunks.join('')
}

function latin1ToBytes(text) {
  const bytes = new Uint8Array(text.length)
  for (let i = 0; i < text.length; i += 1) {
    bytes[i] = text.charCodeAt(i) & 0xff
  }
  return bytes
}

export function utf8ToBase64(text) {
  return btoa(unescape(encodeURIComponent(String(text || ''))))
}

export function base64ToUtf8(b64) {
  return decodeURIComponent(escape(atob(b64)))
}

export function attachMenuTextPayload(pdfBuffer, text) {
  const latin1 = bytesToLatin1(pdfBuffer)
  const b64 = utf8ToBase64(text)
  const wrapped = (b64.match(/.{1,76}/g) || ['']).map((line) => `%${line}`).join('\n')
  const stripped = latin1.replace(/\s*%%EOF\s*$/, '')
  const next = `${stripped}\n${MARK_START}\n${wrapped}\n${MARK_END}\n%%EOF\n`
  return latin1ToBytes(next)
}

export function readMenuTextPayload(pdfBuffer) {
  const latin1 = bytesToLatin1(pdfBuffer)
  const match = latin1.match(/%FOODTOGE-MENU-TEXT-v1\r?\n([\s\S]*?)%FOODTOGE-MENU-TEXT-END/)
  if (!match) return ''
  const b64 = match[1].replace(/%/g, '').replace(/\s/g, '')
  if (!b64) return ''
  try {
    return base64ToUtf8(b64).trim()
  } catch (e) {
    return ''
  }
}
